<template>
 <main class="dn-margin-assi">
    <img class="card-img-top" :src="imgsrc">
  </main>
</template>

<script>
import { getProductById } from '@/config/products'

export default {
  name: 'AssiPage',
  data () {
    return {
      imgsrc: ""
    }
  },
  created () {
    const type = this.$route.query.type || '';
    const product = getProductById(type)
    this.imgsrc = product.assiImage
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AssiPage.vue